var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-app", { attrs: { id: "inspire" } }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("b-loading", {
          attrs: {
            "is-full-page": _vm.isFullPage,
            active: _vm.isLoading,
            "can-cancel": true
          },
          on: {
            "update:active": function($event) {
              _vm.isLoading = $event
            }
          }
        }),
        _vm._v(" "),
        _c("div", { attrs: { id: "header" } }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "sidebar sidebar-fixed bg-white",
              attrs: { id: "sidebarMenu" }
            },
            [
              _c("div", { staticClass: "sidebar-header" }, [
                _c("h5", [_vm._v("Search")]),
                _vm._v(" "),
                _c("a", { attrs: { href: "", id: "sidebarMenuClose" } }, [
                  _c("i", { attrs: { "data-feather": "x" } })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-body" })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content content-components" }, [
          _c(
            "div",
            { staticClass: "container pd-x-0 pd-lg-x-12 pd-xl-x-0 bs" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
                },
                [
                  _c("div", [
                    _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
                      _c(
                        "ol",
                        { staticClass: "breadcrumb breadcrumb-style1 mg-b-10" },
                        [
                          _c("li", { staticClass: "breadcrumb-item" }, [
                            _vm._v(_vm._s(this.mainName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "li",
                            {
                              staticClass: "breadcrumb-item active",
                              attrs: { "aria-current": "page" }
                            },
                            [_vm._v(_vm._s(this.subName))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("h4", { staticClass: "mg-b-0 tx-spacing--1" }, [
                        _vm._v(_vm._s(this.subName))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-none d-md-block" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                        on: {
                          click: function($event) {
                            return _vm.createData()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "wd-10 mg-r-5",
                          attrs: { "data-feather": "folder" }
                        }),
                        _vm._v("Save")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5",
                        on: {
                          click: function($event) {
                            return _vm.goList()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "wd-10 mg-r-5",
                          attrs: { "data-feather": "file" }
                        }),
                        _vm._v("list")
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mg-t-50" }, [
                _c("div", { staticClass: "card ht-100p" }, [
                  _c("div", { staticClass: "row row-xs" }, [
                    _c("div", { staticClass: "col-sm-6 col-lg-12" }, [
                      _c(
                        "div",
                        { staticClass: "card card-body flex-column-inherit" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-lg-5 d-inline-block" },
                            [
                              _c(
                                "form",
                                {
                                  staticClass:
                                    "card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block",
                                  attrs: {
                                    action: "form-validation.html",
                                    "data-parsley-validate": ""
                                  }
                                },
                                [
                                  _vm._l(_vm.inputSearchForms, function(
                                    form,
                                    i
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "list-group-item list-group-item-padding"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: form.id } },
                                              [
                                                _vm._v(_vm._s(form.name)),
                                                form.attr == "equipmentname"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "tx-danger"
                                                      },
                                                      [_vm._v("*")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.lazy",
                                                  value:
                                                    _vm.equipmentData[form.id],
                                                  expression:
                                                    "equipmentData[form.id]",
                                                  modifiers: { lazy: true }
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "email",
                                                name: form.id,
                                                id: form.id,
                                                placeholder: form.name
                                              },
                                              domProps: {
                                                value:
                                                  _vm.equipmentData[form.id]
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.$set(
                                                    _vm.equipmentData,
                                                    form.id,
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.radioSearchForms, function(
                                    form,
                                    i
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "form-row col-md-5 d-block"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "label-title" },
                                              [_vm._v(_vm._s(form.name))]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(form.value, function(
                                              form1,
                                              i
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ml-2 custom-control custom-radio mb-1"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.equipmentData[
                                                            form.id
                                                          ],
                                                        expression:
                                                          "equipmentData[form.id]"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "custom-control-input",
                                                    attrs: {
                                                      type: "radio",
                                                      id: form1.codeCode,
                                                      name: form.id
                                                    },
                                                    domProps: {
                                                      value: form1.codeCode,
                                                      checked:
                                                        form1.codeCode ==
                                                        _vm.equipmentData[
                                                          form.id
                                                        ],
                                                      checked: _vm._q(
                                                        _vm.equipmentData[
                                                          form.id
                                                        ],
                                                        form1.codeCode
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          _vm.equipmentData,
                                                          form.id,
                                                          form1.codeCode
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "custom-control-label",
                                                      attrs: {
                                                        for: form1.codeCode
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(form1.codeName)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  this.saveMode == "update"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "modeRedering form-row float-left"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "label-title" },
                                                [_vm._v("Status")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-group" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-2 custom-control custom-radio mb-1"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value: _vm.usedCode,
                                                            expression:
                                                              "usedCode",
                                                            modifiers: {
                                                              trim: true
                                                            }
                                                          }
                                                        ],
                                                        staticClass:
                                                          "custom-control-input",
                                                        attrs: {
                                                          type: "radio",
                                                          name: "usedcode",
                                                          id: "usedcode1",
                                                          value: "1"
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm.usedCode,
                                                            "1"
                                                          )
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.usedCode = "1"
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "usedcode1"
                                                          }
                                                        },
                                                        [_vm._v("Used")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-2 custom-control custom-radio mb-1"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value: _vm.usedCode,
                                                            expression:
                                                              "usedCode",
                                                            modifiers: {
                                                              trim: true
                                                            }
                                                          }
                                                        ],
                                                        staticClass:
                                                          "custom-control-input form-check-input",
                                                        attrs: {
                                                          type: "radio",
                                                          name: "usedcode",
                                                          id: "usedcode0",
                                                          value: "0"
                                                        },
                                                        domProps: {
                                                          checked: _vm._q(
                                                            _vm.usedCode,
                                                            "0"
                                                          )
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.usedCode = "0"
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "custom-control-label",
                                                          attrs: {
                                                            for: "usedcode0"
                                                          }
                                                        },
                                                        [_vm._v("Unused")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-sm-6 col-lg-5 d-inline-block" },
                            [
                              _c(
                                "form",
                                {
                                  staticClass:
                                    "card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block",
                                  attrs: {
                                    action: "form-validation.html",
                                    "data-parsley-validate": ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "list-group-item list-group-item-padding"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", {}, [_vm._v("비고")]),
                                          _vm._v(" "),
                                          _c("b-input", {
                                            attrs: {
                                              maxlength: "200",
                                              type: "textarea"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", {}, [_vm._v("이미지")]),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            { staticClass: "sidebar-nav" },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "d-block mb-1 has-text-weight-semibold"
                                                },
                                                [
                                                  _vm._v(
                                                    "Sample Box Image upload"
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c("imgUpload", {
                                                on: {
                                                  imgFileHandler: this
                                                    .imgFileHandler
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card card-body p-1 paste-background-color"
                                            },
                                            [
                                              _c("input", {
                                                staticClass:
                                                  "img-input paste-background-color",
                                                attrs: {
                                                  type: "text",
                                                  multiple: "multiple",
                                                  placeholder:
                                                    "Paste your images here"
                                                },
                                                on: { paste: _vm.onPaste }
                                              }),
                                              _vm._v(" "),
                                              _c("img", {
                                                attrs: { id: "pasteImg" }
                                              }),
                                              _vm._v(" "),
                                              _c("p", {
                                                staticClass: "m-0",
                                                attrs: { id: "countPasteImg" }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.imgData.length > 0
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-carousel",
                                                    _vm._l(
                                                      _vm.imgData,
                                                      function(item, i) {
                                                        return _c(
                                                          "v-carousel-item",
                                                          {
                                                            key: item.id,
                                                            attrs: {
                                                              src:
                                                                "data:" +
                                                                item.type.trim() +
                                                                ";base64," +
                                                                item.img,
                                                              "reverse-transition":
                                                                "fade-transition",
                                                              transition:
                                                                "fade-transition"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  depressed: "",
                                                                  color:
                                                                    "primary",
                                                                  block: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.dialogHandler(
                                                                      "delete"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\r\n                                                                Delete Image\r\n                                                            "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-dialog",
                                                              {
                                                                staticStyle: {
                                                                  "z-index":
                                                                    "20001"
                                                                },
                                                                attrs: {
                                                                  transition:
                                                                    "dialog-bottom-transition",
                                                                  "max-width":
                                                                    "300"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.deleteDialog,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.deleteDialog = $$v
                                                                  },
                                                                  expression:
                                                                    "deleteDialog"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-center"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-sheet",
                                                                      {
                                                                        staticClass:
                                                                          "px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "text-body-2 mb-4"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Are you sure you want to delete this image? "
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticClass:
                                                                              "ma-1",
                                                                            attrs: {
                                                                              color:
                                                                                "grey",
                                                                              plain:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                _vm.deleteDialog = false
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Cancel"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            staticClass:
                                                                              "ma-1",
                                                                            attrs: {
                                                                              loading:
                                                                                _vm.deleteLoading,
                                                                              color:
                                                                                "error",
                                                                              plain:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.deleteImgFile(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " Delete "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _c("v-card-text", [
                                                _vm._v(
                                                  "\r\n                                                        이미지 없음\r\n                                                    "
                                                )
                                              ])
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4980c306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4980c306","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Sequencing/Equipment/DetailForm.vue
// module id = null
// module chunks = 